import { createAction } from 'redux-act';

/**
 * Create action
 */

const clearProcess = createAction('CLEAR_PROCESS_FOR_PROJECT');

export default clearProcess;
